import { FieldInputProps, FormikProps } from "formik";

interface CheckboxCellProps extends FieldInputProps<any> {
  hasError?: boolean;
  form: FormikProps<any>;
}

const CheckboxCell = ({
  name,
  value,
  onChange,
  onBlur,
  form,
  ...props
}: CheckboxCellProps) => {
  const handleValueChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      target: {
        name,
        value: e.target.checked,
      },
    });
    form.handleSubmit();
  };

  return (
    <div className="relative flex items-center rounded-l-md">
      <input
        {...props}
        type="checkbox"
        name={name}
        checked={!!value}
        onChange={handleValueChange}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onBlur(e as unknown as React.FocusEvent<HTMLInputElement>);
          }
        }}
        className={`ml-4 checkbox border-gray-300 [--chkbg:theme(colors.custom-dark-purple)] [--chkfg:white] checked:border-transparent mr-2 ${
          props.hasError ? "placeholder-red-500" : ""
        }`}
        placeholder={props.hasError ? "*Required" : ""}
      />
    </div>
  );
};

export default CheckboxCell;
